import { useState } from 'react'

import UserService from 'services/user.service'

import Modal from 'components/elements/Modal'
import PhatButton from 'components/formElements/PhatButton'
import TextArea from 'components/formElements/TextArea'
import ToastService from 'services/toast.service'

import styles from './reportModal.module.scss'

type Props = {
  type: string // Used to group reports
  url: string // link that will be direcly posted to moderators
  open: boolean
  onClose: () => void
  header?: string
  usedInOverlay?: boolean
}

const ReportModal = ({ open, onClose, url, type, header, usedInOverlay = false }: Props) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''

  const [loading, setLoaing] = useState(false)
  const [message, setMessage] = useState('')

  const handleReportIssue = () => {
    setLoaing(true)

    const origin = typeof window !== 'undefined' ? window.location.origin : ''
    const fullUrl = `${origin}${url}`

    return UserService.reportToModerator(fullUrl, type, message)
      .then(() => {
        ToastService.create('Your report has been successfully delivered', 'Reporting Service', 'success')

        setMessage('')
        onClose()
      })
      .catch(err => ToastService.create(err.status, 'Reporting Service', 'error'))
      .finally(() => setLoaing(false))
  }

  return (
    <Modal open={open} onClose={onClose} closeButton usedInOverlay={usedInOverlay}>
      <h3>{header || 'Report item to Archidekt moderators'}</h3>

      <p className={styles.warning}>
        Please note: These are manually reviewed by real humans. If you're using this to meme, please don't.
      </p>

      <TextArea
        header="Reason for reporting"
        value={message}
        onChange={setMessage}
        disabled={loading}
        placeholder="This is inappropriate because..."
        noResize
      />
      <div className={styles.controls}>
        <PhatButton color="red" onClick={onClose} disabled={loading}>
          Cancel
        </PhatButton>
        <PhatButton color="green" onClick={handleReportIssue} disabled={loading}>
          Report issue
        </PhatButton>
      </div>
    </Modal>
  )
}

export default ReportModal
